import type { SignoffPrimary } from '@/journey/_lib/compose-stand'
import { GUEST_SIGNIN_HREF } from '@/lib/auth/guest'

// Guest-mode spec §4: the destinations a guest may follow from the
// dashboard. Everything else becomes the sign-in ask, in the product's own
// sign-off line (decision 3).
const GUEST_REACHABLE = [
    /^\/journey\/?$/,
    /^\/journey\/lessons\/1\/?$/,
    /^\/journey\/lessons\/1\/learn(\/.*)?$/,
]

export function isGuestReachable(href: string): boolean {
    return GUEST_REACHABLE.some((re) => re.test(href))
}

/** Swap a denied sign-off target for the sign-in ask; otherwise pass through. */
export function guestSignoff(
    primary: SignoffPrimary | null,
    isGuest: boolean
): SignoffPrimary | null {
    if (!isGuest || !primary || isGuestReachable(primary.href)) return primary
    return {
        verb: 'Sign in to keep your place',
        lessonNumber: null,
        pathLabel: '',
        href: GUEST_SIGNIN_HREF,
    }
}
